import { IMPROVE_CONFIG } from "@/config.js";
import axios from "axios";

export default {
  getCourses: function(params, searchParams, id = 0) {
    searchParams = (searchParams) ? searchParams : "";
    if(id != 0) {
      return axios.get(IMPROVE_CONFIG.API_URL + "/courses" + params + searchParams + "&id=" + id);
    } else {
      return axios.get(IMPROVE_CONFIG.API_URL + "/courses" + params + searchParams);
    }
  },
  getPublishedCourses: function(params, searchParams) {
    searchParams = (searchParams) ? searchParams : "";
    return axios.get(IMPROVE_CONFIG.API_URL + "/published-courses" + params + searchParams);
  },
  getCourse: function(id, params) {
    return axios.get(IMPROVE_CONFIG.API_URL + "/courses/" + id + params);
  },
  generatePDF: function(id, data) {
    return axios.get(IMPROVE_CONFIG.API_URL + "/course/pdf/" + id, {
      id: data.id,
      course_name: data.course_name,
      user: data.user,
      date: data.date
    });
  },
  publishCourse: function(id) {
    return axios.post(IMPROVE_CONFIG.API_URL + "/course/unpublish/" + id);
  },
  togglePublish: function(courses, state) {
    return axios.post(IMPROVE_CONFIG.API_URL + "/course/toggle-publish", {
      state: state,
      courses: courses
    });
  },
  unPublishCourse: function(id) {
    return axios.post(IMPROVE_CONFIG.API_URL + "/course/publish/" + id);
  },
  deleteCourse: function(id) {
    return axios.delete(IMPROVE_CONFIG.API_URL + "/courses/" + id);
  },
  getCourseMaterials: function(id) {
    return axios.get(
      IMPROVE_CONFIG.API_URL + "/course/materials/" + id + "?limit=99999"
    );
  },
  getCourseUnenrolledUsers: function(courseId, params, search) {
    return axios.get(
      IMPROVE_CONFIG.API_URL + "/course/unenrolled-users/" + courseId + params + search
    );
  },
  getCourseEnrolledUsers: function(courseId, params, search) {
    if(search==undefined) {
      return axios.get(
        IMPROVE_CONFIG.API_URL + "/course/enrolled-users/" + courseId + params
      );
    } else {
      return axios.get(
        IMPROVE_CONFIG.API_URL + "/course/enrolled-users/" + courseId + params + search
      );
    }
  },
  getCourseEnrolledIndividualUsers: function(courseId, params) {
    return axios.get(
      IMPROVE_CONFIG.API_URL + "/course/enrolled-individual-users/" + courseId + params
    );
  },
  getCourseEnrolledGroups: function(courseId, params) {
    return axios.get(
      IMPROVE_CONFIG.API_URL + "/course/enrolled-groups/" + courseId + params
    );
  },
  getCourseUnenrolledGroups: function(courseId, params, search) {
    return axios.get(
      IMPROVE_CONFIG.API_URL + "/course/unenrolled-groups/" + courseId + params + search
    );
  },
  updateCourse: function(id, course, s3, file) {
    var payload = {
      name: course.name,
      description: course.description,
      hours: course.hours,
      minutes: course.minutes,
      topics: course.topics,
      channels: course.channels,
      s3_url: s3,
      file: file,
      category_id: course.category_id,
      archive_after: course.archive_after,
    };
    // Whether a brand new customer receives this course. Only meaningful on the
    // template company's own courses, and the API ignores it for any other, so
    // it is sent only when the API said this is a template course. Omitting the
    // key leaves the stored value untouched.
    if (course.is_template_course) {
      payload.in_default_set = !!course.in_default_set;
    }
    return axios.put(IMPROVE_CONFIG.API_URL + "/courses/" + id, payload);
  },
  updateSort: function(id, order) {
    return axios.post(
      IMPROVE_CONFIG.API_URL + "/course/training-material/sort/" + id,
      {
        sort_order: order
      }
    );
  },
  installCourses: function() {
    return axios.post(IMPROVE_CONFIG.API_URL + "/install/courses");
  },
  createCourse: function(course, s3, file) {
    return axios.post(IMPROVE_CONFIG.API_URL + "/courses", {
      name: course.name,
      description: course.description,
      hours: course.hours,
      minutes: course.minutes,
      topics: course.topics,
      channels: course.channels,
      s3_url: s3,
      file: file,
      category_id: course.category_id
    });
  },
  removeCourseMaterial: function(courseId, id) {
    return axios.post(
      IMPROVE_CONFIG.API_URL + "/course/remove/training-material",
      {
        course_id: courseId,
        asset_id: id
      }
    );
  },
  addDocument: function(doc, s3, file) {
    return axios.post(
      IMPROVE_CONFIG.API_URL + "/course/add/training-material",
      {
        course: doc.courseId,
        title: doc.title,
        description: doc.description,
        type: "document",
        s3_url: s3,
        file: file
      }
    );
  },
  editDocument: function(doc) {
    return axios.patch(
      IMPROVE_CONFIG.API_URL + "/assets/"+doc.assetId,
      {
        title: doc.title,
        description: doc.description,
      }
    );
  },
  addExternalLink: function(link) {
    return axios.post(
      IMPROVE_CONFIG.API_URL + "/course/add/training-material",
      {
        course: link.courseId,
        title: link.title,
        description: link.description,
        url: link.url,
        type: "link"
      }
    );
  },
  addAsset: function(asset, s3, file) {
    return axios.post(
      IMPROVE_CONFIG.API_URL + "/course/add/training-material",
      {
        s3_url: s3,
        file: file,
        course: asset.courseId,
        title: asset.title,
        description: asset.description,
        type: asset.type
      }
    );
  },
  addVideo: function(asset, s3, file) {
    return axios.post(
      IMPROVE_CONFIG.API_URL + "/course/add/training-material",
      {
        s3_url: s3,
        file: file,
        course: asset.courseId,
        title: asset.title,
        description: asset.description,
        type: "video"
      }
    );
  },
  enrolUsers: function(id, data) {
    return axios.post(IMPROVE_CONFIG.API_URL + "/course/enrol/" + id, {
      assign_users: data.assign_users,
      unassign_users: data.unassign_users,
      assign_groups: data.assign_groups,
      unassign_groups: data.unassign_groups,
      selected_date: data.selectedDate,
      enrol_all: data.enrolAll ? data.enrolAll : false
    });
  },
  updateDeadline: function(id, data) {
    return axios.post(IMPROVE_CONFIG.API_URL + "/course/manage-deadlines/" + id, {
      users: data.users,
      groups: data.groups,
      selected_date: data.selectedDate
    });
  },
  removeUsersAndGroups: function(id, data) {
    return axios.post(IMPROVE_CONFIG.API_URL + "/course/remove-user-and-groups/" + id, {
      users: data.users,
      groups: data.groups
    });
  },
  reseedCourse: function (id) {
    return axios.post(IMPROVE_CONFIG.API_URL + "/course-seed-manually/"+id);
  },
  getCourseUnenrolledCustomers: function(courseId, params, search) {
    return axios.get(
        IMPROVE_CONFIG.API_URL + "/course/unenrolled-customers/" + courseId + params + search
    );
  },
  assignCourseToCustomers: function(id, data) {
    return axios.post(IMPROVE_CONFIG.API_URL + "/course/copy/" + id, {
      users: data.users,
      groups: data.groups,
      selected_date: data.selectedDate
    });
  },
  exportCourse: function(params, search, type) {
    return axios.get(IMPROVE_CONFIG.API_URL + "/courses-export" + params + search + type);
  },
  exportEnrolledUsers: function(courseId, params, type) {
    return axios.get(
      IMPROVE_CONFIG.API_URL + "/course/enrolled-users-export/" + courseId + params
    );
  },
  addPowerpoint: function(doc, s3, file) {
    return axios.post(
      IMPROVE_CONFIG.API_URL + "/course/add/training-material",
      {
        course: doc.courseId,
        title: doc.title,
        description: doc.description,
        type: "powerpoint",
        s3_url: s3,
        file: file
      }
    );
  },
  getUnenrolledChannelCourses: function(params, id) {
      return axios.get(IMPROVE_CONFIG.API_URL + "/unenrolled-channel-courses" + params + "&id=" + id);
  },
  getEnrolledChannelCourses: function(params, id) {
    return axios.get(IMPROVE_CONFIG.API_URL + "/enrolled-channel-courses" + params + "&id=" + id);
  },
  getCoursesData: function(params, searchParams) {
    searchParams = (searchParams) ? searchParams : "";
    return axios.get(IMPROVE_CONFIG.API_URL + "/courses-data" + params + searchParams);
  },
  getMyPublishedCourses: function(params, courseStatus) {
    return axios.get(IMPROVE_CONFIG.API_URL + "/my-published-courses" + params + "&type=" + courseStatus);
  },
  getCoursesReport: function(params, searchParams) {
    searchParams = (searchParams) ? searchParams : "";
    return axios.get(IMPROVE_CONFIG.API_URL + "/courses-report-data" + params + searchParams);
  },
  getCourseEditInfo: function(id, params) {
    return axios.get(IMPROVE_CONFIG.API_URL + "/course-edit-info/" + id + params);
  },
  assignCourseToPartners: function(id, data) {
    return axios.post(IMPROVE_CONFIG.API_URL + "/course/copy/" + id, {
      users: data.users,
      groups: data.groups,
      selected_date: data.selectedDate
    });
  },
  archiveUserCourse: function(id) {
    return axios.post(IMPROVE_CONFIG.API_URL + "/archive-user-course/" + id);
  },
  getUserCourseHistory: function(courseId) {
    return axios.get(
      IMPROVE_CONFIG.API_URL + "/course-user-history/" + courseId
    );
  },
  archiveAllUserCourseData: function(id) {
    return axios.post(IMPROVE_CONFIG.API_URL + "/archive-all-user-course/" + id);
  },
  exportArchivedUserCourseCSV: function(userId, params, type) {
    return axios.get(
      IMPROVE_CONFIG.API_URL + "/course/archived-user-course-export/" + userId + params + type
    );
  },
  exportUserCourseReportCSV: function(userId, params, type) {
    return axios.get(
      IMPROVE_CONFIG.API_URL + "/course/user-course-report-export/" + userId + params + type
    );
  },
  getUnEnrollCourses: function(params, id) {
    return axios.get(IMPROVE_CONFIG.API_URL + "/unenrolled-user-courses" + params + "&id=" + id);
  },
  getEnrolCourses: function(params, id) {
      return axios.get(IMPROVE_CONFIG.API_URL + "/enrolled-user-courses" + params + "&id=" + id);
  },
  enrolCourses: function(id, data) {
    return axios.post(IMPROVE_CONFIG.API_URL + "/enrol/courses/" + id, {
      assign_courses: data.assign_courses,
      unassign_courses: data.unassign_courses
    });
  },
  enrolStaffCourse: function(id, data) {
    return axios.post(IMPROVE_CONFIG.API_URL + "/enrol/users-to-courses", {
      assign_courses: data.assign_courses,
      users: data.assign_users
    });
  },
  addScorm: function(doc, s3, file) {
    return axios.post(
      IMPROVE_CONFIG.API_URL + "/course/add/training-material",
      {
        course: doc.courseId,
        title: doc.title,
        description: doc.description,
        type: "scorm",
        s3_url: s3,
        file: file
      }
    );
  },
  getcompanyCourseEnrolledUsers: function(courseId,companyid, params, search) {
    if(search==undefined) {
      return axios.get(
        IMPROVE_CONFIG.API_URL + "/course/"+companyid+"/enrolled-users/" + courseId + params
      );
    } else {
      return axios.get(
        IMPROVE_CONFIG.API_URL + "/course/"+companyid+"/enrolled-users/" + courseId + params + search
      );
    }
  },
  getAllCourseCategories: function() {
    return axios.get(
      IMPROVE_CONFIG.API_URL + "/get_all_course_categories"
    );
  },
  addCourseCategory: function(category) {
    return axios.post(
      IMPROVE_CONFIG.API_URL + "/course_category/add",
      {
        name: category.name,
      }
    );
  },
  deleteCourseCategory: function(id) {
    return axios.delete(IMPROVE_CONFIG.API_URL + "/delete-course-category/" + id);
  },
  updateCourseCategory: function(id, category) {
    return axios.put(IMPROVE_CONFIG.API_URL + "/course_category/" + id, {
      name: category.name,
    });
  },
  archiveCourse: function(id,archive) {
    return axios.post(IMPROVE_CONFIG.API_URL + "/archive-course/" + id + '/' + archive);
  },
  getCompletedCourses: function(params,user_id){
    return axios.get(IMPROVE_CONFIG.API_URL + "/users/completed_courses/" + user_id + params);
  },
  archiveUserCourses: function(courseUserIds) {
    return axios.post(IMPROVE_CONFIG.API_URL + "/archive-user-courses",courseUserIds);
  },
  getCompletedCourseUsers: function(params,course_id){
    return axios.get(IMPROVE_CONFIG.API_URL + "/completed_course_users/" + course_id + params);
    // return axios.get(`${IMPROVE_CONFIG.API_URL}/completed_course_users/${course_id}`, {
    //   params: params
    // });
  },
  markCourseCompleted: function(course_user_id, course_id){
    return axios.post(IMPROVE_CONFIG.API_URL + "/mark_course_completed",{
      'entity_lookup_user_id' : course_user_id,
      'related_entity' : course_id
    });
  },
  getDefaultCourse: function(params) {
    return axios.get(IMPROVE_CONFIG.API_URL + "/default-courses" + params);
  },
  getCourseUpdateNotification: function(courseId){
   return axios.get(IMPROVE_CONFIG.API_URL + "/course/get-course-update-notification/" + courseId);
  },
  saveCourseUpdateNotification: function(data){
    return axios.post(IMPROVE_CONFIG.API_URL + "/course/save-course-update-notification",{
      id: data.id,
      course_id: data.course_id,
      course_name: data.course_name,
      notification_type: data.type,
      description: data.description,
      notification_display_days: data.notification_display_days,
    });
  },
  getNotCompletedCoursesForUser: function(params,user_id){
    return axios.get(IMPROVE_CONFIG.API_URL + "/users/not_completed_courses/" + user_id + params);
  },
  markCoursesCompleted: function(course_user_id){
    return axios.post(IMPROVE_CONFIG.API_URL + "/mark_courses_completed",{
      'entity_lookup_user_id' : course_user_id
    });
  },
  // Unexpired New/Updated course alerts for the signed-in user's company.
  // Readable by every role, unlike the owner-gated per-course endpoint.
  getActiveCourseUpdateNotifications: function(){
    return axios.get(IMPROVE_CONFIG.API_URL + "/course/active-course-update-notifications");
  },
  getNotCompletedCourseUsers: function(params,course_id){
    // return axios.get(`${IMPROVE_CONFIG.API_URL}/not_completed_course_users/${course_id}`+params);
    return axios.get(IMPROVE_CONFIG.API_URL + "/not_completed_course_users/" + course_id + params);
  },
};
